/**
 * Incident Layout
 * 
 * Layout wrapper for incident pages that includes:
 * - IncidentAssistantProvider for shared context
 * - AppShell (global AI Assistant Panel auto-detects incident context)
 */

import { Outlet } from 'react-router-dom';
import { AppShell } from './AppShell';
import { IncidentAssistantProvider } from '../../context/IncidentAssistantContext';

/**
 * Main layout component that wraps everything in the provider.
 * The global AIAssistantPanel in AppShell will auto-detect incident context.
 */
export function IncidentLayout() {
  return (
    <IncidentAssistantProvider>
      <AppShell>
        <Outlet />
      </AppShell>
    </IncidentAssistantProvider>
  );
}
